import React, { useState, useEffect } from 'react';

export const Hero = ({ styles }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header style={{
      ...styles.hero,
      height: isMobile ? '65vh' : '75vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>

      <h1 style={{
        ...styles.mainTitle,
        ...(isMobile && {
          fontSize: '1.65rem',
          letterSpacing: '1px',
          lineHeight: '1.2',
        }),
      }}>
        SAY <span style={{
          ...ciaoStyle,
          ...(isMobile && { letterSpacing: '4px', marginLeft: '6px' }),
        }}>CIAO</span> TO YOUR <br />
        OWN ITALIAN VOICE
      </h1>

      <p style={{ ...styles.heroSub, margin: '20px auto', opacity: 0.8 }}>
        Over 2,500 lessons with English-speaking adults. <br />
        Focused on clarity, culture, and conversation.
      </p>

      <div style={styles.heroActions}>
        <div style={subtitleStyle}>
          Private Online Sessions • $50 / hr
        </div>
      </div>

      {isMobile && (
        <div style={scrollHintStyle}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5 L12 19 M6 13 L12 19 L18 13"
              stroke="#BC6C25"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}

    </header>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const ciaoStyle = {
  fontStyle: 'normal',
  letterSpacing: '8px',
  color: '#BC6C25',
  fontWeight: 600,
  marginLeft: '10px',
  paddingBottom: '2px',
};

const subtitleStyle = {
  marginTop: '15px',
  fontSize: '0.85rem',
  letterSpacing: '2px',
  opacity: 0.7,
  color: '#283618',
  textTransform: 'uppercase',
};

const scrollHintStyle = {
  position: 'absolute',
  bottom: '40px',
  left: '50%',
  transform: 'translateX(-50%)',
  animation: 'bounce 2s ease-in-out infinite',
  opacity: 0.6,
};